import { useState, useEffect } from "react"
import { PUBLIC_FEATURE_CATALOG_INFO } from "../api/QuadriApi"
import { useRecoilValue } from "recoil"
import { featureCatalogIdState } from "./StateSelectors"
import { useQuery } from "@apollo/client"
import { useTranslation } from "react-i18next"
import GetEnvironment from "../environments"

interface ProjectFeatureCatalogLinkProps {
  quadriConfigurationUiUrl: string
}

const ProjectFeatureCatalogLink = (props: ProjectFeatureCatalogLinkProps) => {
  const { t } = useTranslation("config")
  const [fc, setFC] = useState<string | undefined>()
  const existingFcId = useRecoilValue(featureCatalogIdState)

  // get the existing feature catalogue
  const exactFCQuery = useQuery(PUBLIC_FEATURE_CATALOG_INFO, {
    variables: { id: existingFcId }
  })
  const exactFC = exactFCQuery.data?.publicFeatureCatalogInfo

  useEffect(() => {
    if (existingFcId && exactFC) {
      setFC(exactFC.displayText)
    } else {
      setFC("Not Available")
    }
  }, [exactFC, existingFcId])

  return (
    <div>
      <a
        target="_blank"
        rel="noreferrer noopener"
        href={existingFcId ? `${props.quadriConfigurationUiUrl}#/featurecatalogdetails/${existingFcId}` : undefined}
        data-testid="quadri-feature-catalog-link"
      >
        {t("quadriProjectSettings.featureCatalog")}: {fc}
      </a>
    </div>
  )
}

export default ProjectFeatureCatalogLink
